import React from 'react';
import { SC } from 'src/styles/theme';
import { PrePreOrderCheckoutTransitionOverlayStyledAC } from './AC/PrePreOrderCheckoutTransitionOverlayStyled.AC';
import { PrePreOrderCheckoutTransitionOverlayStyledAP } from './AP/PrePreOrderCheckoutTransitionOverlayStyled.AP';
import { PrePreOrderCheckoutTransitionOverlayStyledDS } from './DS/PrePreOrderCheckoutTransitionOverlayStyled.DS';
import { PrePreOrderCheckoutTransitionOverlayStyledOV } from './OV/PrePreOrderCheckoutTransitionOverlayStyled.OV';
import { PrePreOrderCheckoutTransitionOverlayStyledOVGB } from './OV/PrePreOrderCheckoutTransitionOverlayStyled.OVGB';
import { PrePreOrderCheckoutTransitionOverlayStyled } from './PrePreOrderCheckoutTransitionOverlayStyled';
import { BRAND, isMarketGB } from 'src/constants/main';

export interface IProps extends SC {
    transitionOverlayError: boolean;
    isAssistedFinance: boolean;
    handleRedirect: () => void;
}

export const PrePreOrderCheckoutTransitionOverlay = (props: IProps) => {
    if (BRAND === 'AC') return <PrePreOrderCheckoutTransitionOverlayStyledAC {...props} />;
    if (BRAND === 'AP') return <PrePreOrderCheckoutTransitionOverlayStyledAP {...props} />;
    if (BRAND === 'DS') return <PrePreOrderCheckoutTransitionOverlayStyledDS {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? (
            <PrePreOrderCheckoutTransitionOverlayStyledOVGB {...props} />
        ) : (
            <PrePreOrderCheckoutTransitionOverlayStyledOV {...props} />
        );
    return <PrePreOrderCheckoutTransitionOverlayStyled {...props} />;
};
